// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-history-overlay-container {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  align-items: baseline;
  justify-content: flex-end;
  height: 90%;
  max-height: 80vh;

  --history-width: 400px;
}

.event-history-overlay {
  display: flex;
  gap: var(--dialog-element-gap);
  pointer-events: none;
  max-width: var(--history-width);
  min-width: var(--history-width);
  overflow: hidden;
  flex-wrap: wrap;
  flex-direction: column-reverse;
  align-items: baseline;
}

.event-history-overlay a {
  pointer-events: all;
}

.event-history-overlay-item {
  display: flex;
  flex-direction: column;
  gap: calc(var(--input-element-gap) / 2);
  padding-top: calc(var(--input-element-gap) / 2);
  padding-left: var(--dialog-element-gap);
  padding-right: var(--dialog-element-gap);
  padding-bottom: var(--input-element-gap);
  border-radius: var(--dialog-border-radius);
  background-color: var(--input-background-color);
  min-width: var(--history-width);
  max-width: var(--history-width);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  max-height: 155px;
}

.event-history-overlay-item-fade-out {
  width: 100%;
  height: var(--input-element-gap);
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    var(--input-background-color) 100%
  );
  border-bottom-right-radius: var(--dialog-border-radius);
  border-bottom-left-radius: var(--dialog-border-radius);
}

.event-history-overlay-item-me .event-history-overlay-item-fade-out {
  background: linear-gradient(
    to bottom,
    transparent 0%,
    var(--light-blue-background-color) 100%
  );
}

.event-history-overlay-item-me {
  background-color: var(--light-blue-background-color);
}

.event-history-overlay-item-me .event-history-overlay-item-author {
  color: var(--info-color);
  text-align: right;
}

.event-history-overlay-item-content {
  display: flex;
  flex-direction: row;
  gap: var(--dialog-element-gap);
  align-items: flex-start;
}

.event-history-overlay-item-main-content {
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);
  flex-grow: 1;
  overflow: hidden;
  word-wrap: break-word;
  padding-top: calc(var(--input-element-gap) / 2);
}

.event-history-overlay-item-main-content .event-history-item-content-image {
  width: 100px;
  height: 75px;
  margin: 0;
  border-radius: var(--dialog-border-radius);
}

.event-history-overlay-item-main-content-upper {
  font-weight: bold;
}

.event-history-overlay-item-author {
  font-size: var(--font-size-s);
  font-weight: bold;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: calc(var(--input-element-gap) / 2);
  word-wrap: break-word;
}

.event-history-overlay-item-button {
  pointer-events: all;
  margin: var(--input-element-gap) 0;
}

.event-history-overlay-item-icon-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: var(--input-element-gap);
  margin-right: 0;
  margin-bottom: var(--input-element-gap);
  margin-left: var(--input-element-gap);
  pointer-events: all;
}

.event-history-overlay-chat-controls-container {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  width: 100%;
  min-width: var(--history-width);
  max-width: var(--history-width);
}

.event-history-overlay-chat-controls-container input,
.event-history-overlay-chat-controls-container button {
  pointer-events: all;
}

.event-history-overlay-chat-controls-container button {
  background-color: var(--dialog-background-color);
}

.event-history-overlay-input-container {
  position: relative;
  flex-grow: 1;

  > input {
    width: 100%;
    padding-right: var(--input-element-height);
  }

  > button {
    position: absolute;
    right: 0;
    top: 0;
    background-color: transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/event-history-list/event-history-overlay/EventHistoryOverlay.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;;EAEhB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,+CAA+C;EAC/C,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;EAC1C,+CAA+C;EAC/C,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP;;;;GAIC;EACD,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,4CAA4C;EAC5C,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,YAAY;;EAEZ;IACE,WAAW;IACX,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,6BAA6B;EAC/B;AACF","sourcesContent":[".event-history-overlay-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  align-items: baseline;\n  justify-content: flex-end;\n  height: 90%;\n  max-height: 80vh;\n\n  --history-width: 400px;\n}\n\n.event-history-overlay {\n  display: flex;\n  gap: var(--dialog-element-gap);\n  pointer-events: none;\n  max-width: var(--history-width);\n  min-width: var(--history-width);\n  overflow: hidden;\n  flex-wrap: wrap;\n  flex-direction: column-reverse;\n  align-items: baseline;\n}\n\n.event-history-overlay a {\n  pointer-events: all;\n}\n\n.event-history-overlay-item {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--input-element-gap) / 2);\n  padding-top: calc(var(--input-element-gap) / 2);\n  padding-left: var(--dialog-element-gap);\n  padding-right: var(--dialog-element-gap);\n  padding-bottom: var(--input-element-gap);\n  border-radius: var(--dialog-border-radius);\n  background-color: var(--input-background-color);\n  min-width: var(--history-width);\n  max-width: var(--history-width);\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n  max-height: 155px;\n}\n\n.event-history-overlay-item-fade-out {\n  width: 100%;\n  height: var(--input-element-gap);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    var(--input-background-color) 100%\n  );\n  border-bottom-right-radius: var(--dialog-border-radius);\n  border-bottom-left-radius: var(--dialog-border-radius);\n}\n\n.event-history-overlay-item-me .event-history-overlay-item-fade-out {\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    var(--light-blue-background-color) 100%\n  );\n}\n\n.event-history-overlay-item-me {\n  background-color: var(--light-blue-background-color);\n}\n\n.event-history-overlay-item-me .event-history-overlay-item-author {\n  color: var(--info-color);\n  text-align: right;\n}\n\n.event-history-overlay-item-content {\n  display: flex;\n  flex-direction: row;\n  gap: var(--dialog-element-gap);\n  align-items: flex-start;\n}\n\n.event-history-overlay-item-main-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n  flex-grow: 1;\n  overflow: hidden;\n  word-wrap: break-word;\n  padding-top: calc(var(--input-element-gap) / 2);\n}\n\n.event-history-overlay-item-main-content .event-history-item-content-image {\n  width: 100px;\n  height: 75px;\n  margin: 0;\n  border-radius: var(--dialog-border-radius);\n}\n\n.event-history-overlay-item-main-content-upper {\n  font-weight: bold;\n}\n\n.event-history-overlay-item-author {\n  font-size: var(--font-size-s);\n  font-weight: bold;\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: calc(var(--input-element-gap) / 2);\n  word-wrap: break-word;\n}\n\n.event-history-overlay-item-button {\n  pointer-events: all;\n  margin: var(--input-element-gap) 0;\n}\n\n.event-history-overlay-item-icon-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: var(--input-element-gap);\n  margin-right: 0;\n  margin-bottom: var(--input-element-gap);\n  margin-left: var(--input-element-gap);\n  pointer-events: all;\n}\n\n.event-history-overlay-chat-controls-container {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  width: 100%;\n  min-width: var(--history-width);\n  max-width: var(--history-width);\n}\n\n.event-history-overlay-chat-controls-container input,\n.event-history-overlay-chat-controls-container button {\n  pointer-events: all;\n}\n\n.event-history-overlay-chat-controls-container button {\n  background-color: var(--dialog-background-color);\n}\n\n.event-history-overlay-input-container {\n  position: relative;\n  flex-grow: 1;\n\n  > input {\n    width: 100%;\n    padding-right: var(--input-element-height);\n  }\n\n  > button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
